import TimeseriesReportCollectionBase from 'common/base/timeseries-report-collection-base';
import TimeseriesReportModel from 'common/models/timeseries-report-model';
import TimeseriesReportURL from 'common/urls/timeseries-report-url';
import {t} from 'common/utils/translation-util';

export default TimeseriesReportCollectionBase.extend({
  initialize() {
    this.attributeName = 'value';
    this.errorMessage = t('Timeseries data failed to load.');
    this.model = TimeseriesReportModel;
    this.urlFunc = TimeseriesReportURL;
  },
});
